import { useMsal } from "@azure/msal-react";
import {
  CircularProgress,
  Container,
  Grid,
  Typography,
  Paper,
  IconButton,
  Tooltip,
  Divider,
  Button,
} from "@material-ui/core";
import { FilterList, ArrowForward, Close } from "@material-ui/icons";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { ReactElement, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { globalStyles } from "../../../assets/globalStyles";
import { useStyles } from "./pqIndexStyle";
import ZeitFilter from "../../../features/filter/zeit";
import MessstellenFilter from "../../../features/filter/messstellen";
import KenngroesseFilter from "../../../features/filter/kenngroesse";
import GrenzwertFilter from "./grenzwertFilter";
import UmspannwerkZeitGrid from "./umspannwerkZeitGrid";
import UmspannwerkKenngroesseGrid from "./umspannwerkKenngroesseGrid";
import KenngroesseZeitGrid from "./kenngroesseZeitGrid";
import MessstelleZeitGrid from "./messstelleZeitGrid";
import MessstelleKenngroesseGrid from "./messstelleKenngroesseGrid";
import {
  getGrenzwertsatz,
  selectIsChangedGrenzwert,
  setIsChangedGrenzwert,
  resetAktuellerGrenzwertsatz,
  setAktuellerGrenzwertsatz,
  selectAktuellerGrenzwertsatzTemp,
  selectSelectedTab,
  updateSelectedTab,
  updateSelectedTabAll,
  selectVorherSelectedTab,
  selectFirstLoadOfAnwenden,
  setFirstLoadOfAnwenden,
} from "./pqIndexSlice";
import {
  getKenngroesse,
  setKenngroesseWert,
  selectKenngroesseWert,
  selectKenngroesseWertTemp,
  resetKenngroesseWert,
  selectIsChangedKenngroesse,
  setIsChangedKenngroesse,
} from "../../../features/filter/kenngroesseSlice";
import {
  getMessstellen,
  setMessstelleWert,
  selectMessstelleWert,
  selectMessstelleWertTemp,
  resetMessstelleWert,
  selectIsChangedMessstelle,
  setIsChangedMessstelle,
  selectSliderTemp,
  resetSlider,
  setSlider,
} from "../../../features/filter/messstellenFilterSlice";
import {
  setIsChangedZeit,
  selectIsChangedZeit,
  resetEndeCounter,
  resetStartCounter,
  resetEndeZeitraum,
  resetStartZeitraum,
  resetStartDatum,
  setEndeCounter,
  setEndeZeitraum,
  setStartCounter,
  setStartDatum,
  setStartZeitraum,
  selectStartDatumTemp,
  resetEndeDatum,
  setEndeDatum,
  selectEndeDatumTemp,
  selectEndeCounterTemp,
} from "../../../features/filter/zeitSlice";
import KenngroesseDetailUwGrid from "./kenngroesseDetailUwGrid";
import KenngroesseDetailZeitGrid from "./kenngroesseDetailZeitGrid";
import {
  deleteTabForMessstelleKenngroesse,
  deleteTabForMessstelleZeit,
  selectLoadingMessstellenKenngroesse,
  selectLoadingMessstellenZeit,
  selectMessstelleKenngroesse,
  selectMessstelleZeit,
  setOldTabMessstelle,
} from "./messstelleTableSlice";
import {
  deleteTabForKenngroesseDetailUw,
  deleteTabForKenngroesseDetailZeit,
  selectKenngroesseDetailUw,
  selectKenngroesseDetailZeit,
  selectLoadingKenngroesseDetailUw,
  selectLoadingKenngroesseDetailZeit,
  setOldTabKenngroesse,
} from "./kenngroesseDetailTableSlice";
import {
  getUwZeit,
  selectLoadingUwZeit,
  selectUwZeit,
} from "./uwZeitTableSlice";
import {
  getUwKenngroesse,
  selectLoadingUwKenngroesse,
  selectUwKenngroesse,
} from "./uwKenngroesseGruppeTableSlice";
import {
  getKenngroesseZeit,
  selectKenngroesseZeit,
  selectLoadingKenngroesseZeit,
} from "./kenngroesseGruppeZeitTableSlice";

export default function PqIndex(): ReactElement {
  const { instance } = useMsal();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getGrenzwertsatz());
    dispatch(getMessstellen());
    dispatch(getKenngroesse("pqIndex"));
  }, [instance]);

  const messstelleZeit = useAppSelector(selectMessstelleZeit);
  const messstelleKenngroesse = useAppSelector(selectMessstelleKenngroesse);
  const kenngroesseDetailUw = useAppSelector(selectKenngroesseDetailUw);
  const kenngroesseDetailZeit = useAppSelector(selectKenngroesseDetailZeit);

  const grenzwertsatz = useAppSelector(selectAktuellerGrenzwertsatzTemp);
  const kenngroesseFilterWert = useAppSelector(selectKenngroesseWertTemp);
  const messstelleFilterWert = useAppSelector(selectMessstelleWertTemp);
  const pqIndexSlider = useAppSelector(selectSliderTemp);
  const startDatum = useAppSelector(selectStartDatumTemp);
  const endeDatum = useAppSelector(selectEndeDatumTemp);

  const isChangedGrenzwert = useAppSelector(selectIsChangedGrenzwert);
  const isChangedMessstelle = useAppSelector(selectIsChangedMessstelle);
  const isChangedKenngroesse = useAppSelector(selectIsChangedKenngroesse);
  const isChangedZeit = useAppSelector(selectIsChangedZeit);
  const endDate = useAppSelector(selectEndeCounterTemp);


  const messstelleFilter = useAppSelector(selectMessstelleWert);
  const kenngroesseFilter = useAppSelector(selectKenngroesseWert);

  const uwZeit = useAppSelector(selectUwZeit);
  const uwKenngroesse = useAppSelector(selectUwKenngroesse);
  const kenngroesseZeit = useAppSelector(selectKenngroesseZeit);

  const uwZeitLoading = useAppSelector(selectLoadingUwZeit);
  const uwKenngroesseLoading = useAppSelector(selectLoadingUwKenngroesse);
  const kenngroesseZeitLoading = useAppSelector(selectLoadingKenngroesseZeit);
  const messstelleKenngroesseLoading = useAppSelector(
    selectLoadingMessstellenKenngroesse
  );
  const messstelleZeitLoading = useAppSelector(selectLoadingMessstellenZeit);
  const kenngroesseDetailUwLoading = useAppSelector(
    selectLoadingKenngroesseDetailUw
  );
  const kenngroesseDetailZeitLoading = useAppSelector(
    selectLoadingKenngroesseDetailZeit
  );

  const selectedTabForTables = useAppSelector(selectSelectedTab);
  const vorherSelectedTabForTables = useAppSelector(selectVorherSelectedTab);

  const firstLoadOfAnwenden = useAppSelector(selectFirstLoadOfAnwenden);

  const [selectedTab, setSelectedTab] = React.useState("zeit");
  const [filter, openFilter] = React.useState(true);

  const classes = {
    ...globalStyles(),
    ...useStyles(),
  };

  function closeTab(
    tab: string,
    lengthMessstelleZeit: number,
    lengthMessstelleKenngroesse: number,
    lengthKenngroesseDetailUw: number,
    lengthKenngroesseDetailZeit: number
  ) {
    if (
      (lengthMessstelleZeit == 1 &&
        lengthMessstelleKenngroesse == 0 &&
        lengthKenngroesseDetailUw == 0 &&
        lengthKenngroesseDetailZeit == 0) ||
      (lengthMessstelleZeit == 0 &&
        lengthMessstelleKenngroesse == 1 &&
        lengthKenngroesseDetailUw == 0 &&
        lengthKenngroesseDetailZeit == 0) ||
      (lengthMessstelleZeit == 0 &&
        lengthMessstelleKenngroesse == 0 &&
        lengthKenngroesseDetailUw == 1 &&
        lengthKenngroesseDetailZeit == 0) ||
      (lengthMessstelleZeit == 0 &&
        lengthMessstelleKenngroesse == 0 &&
        lengthKenngroesseDetailUw == 0 &&
        lengthKenngroesseDetailZeit == 1)
    ) {
      dispatch(updateSelectedTabAll("zeitUmspannwerk", "zeitUmspannwerk"));
    } else if (selectedTabForTables == tab) {
      dispatch(updateSelectedTab(vorherSelectedTabForTables));
    }
  }

  return (
    <div>
      <Container maxWidth={false} style={{ marginTop: "10px" }}>
        <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item md={3} />
          <Grid item md={6}>
            <Typography color="primary" variant="h5">
              PQ Index
            </Typography>
          </Grid>
          <Grid item md={12}></Grid>
        </Grid>
      </Container>
      <Paper
        className={classes.paper}
        style={{
          marginLeft: "24px",
          marginRight: "24px",
          marginBottom: "10px",
        }}
      >
        <form
          className={classes.root}
          noValidate
          autoComplete="off"
          style={{ marginBottom: "10px" }}
        >
          <div>
            <Grid container spacing={4} style={{ marginBottom: "10px" }}>
              <Grid container item md={12} style={{ paddingLeft: "16px" }}>
                <Grid container item xs={12} >
                  <Grid item xs={11} ></Grid>
                  {filter ? <Grid item xs={1} style={{ textAlign: "end" }}>
                    <IconButton onClick={() => openFilter(false)}>
                      <Tooltip title="Filter zuklappen">
                        <ArrowForward />
                      </Tooltip>
                    </IconButton>
                  </Grid>
                    :
                    <Grid item xs={1} style={{ textAlign: "end" }}>
                      <IconButton onClick={() => openFilter(true)}>
                        <Tooltip title="Filter aufklappen">
                          <FilterList />
                        </Tooltip>
                      </IconButton>
                    </Grid>
                  }
                </Grid>
                <Grid item md={filter ? 7 : 12}>
                  <Tabs
                    value={selectedTabForTables}
                    onChange={(event, value) =>
                      dispatch(
                        updateSelectedTabAll(value, selectedTabForTables)
                      )
                    }
                    indicatorColor="secondary"
                    textColor="secondary"
                    TabIndicatorProps={{
                      style: {
                        height: "5px",
                      },
                    }}
                  >
                    <Tab
                      fullWidth={true}
                      label="Umspannwerk &amp; Zeit"
                      value="zeitUmspannwerk"
                      style={{ marginRight: "15px" }}
                    />
                    <Tab
                      fullWidth={true}
                      label="Umspannwerk &amp; Kenngröße"
                      value="umspannwerkKenngroesse"
                      style={{ marginRight: "15px" }}
                    />
                    <Tab
                      fullWidth={true}
                      label="Kenngröße &amp; Zeit"
                      value="kenngroesseZeit"
                      style={{ marginRight: "15px" }}
                    />
                    {messstelleZeit.map((elem) => (
                      <Tab
                        fullWidth={true}
                        style={{
                          minWidth: "max-content",
                          marginRight: "15px",
                          color: elem.isOld ? "red" : "",
                        }}
                        key={elem.uw + elem.kategorie}
                        value={elem.uw + elem.kategorie}
                        label={
                          <Grid container>
                            <Grid container item md={12}>
                              <Grid item style={{ alignSelf: "center" }}>
                                <Typography style={{ fontSize: "14px" }}>
                                  {elem.uw + " (Zeit)"}
                                </Typography>
                              </Grid>
                              <Grid item style={{ textAlignLast: "right" }}>
                                <Button
                                  component={"div"}
                                  key={elem.uw + elem.kategorie}
                                  onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    dispatch(
                                      deleteTabForMessstelleZeit(elem.uw)
                                    );
                                    closeTab(
                                      elem.uw + elem.kategorie,
                                      messstelleZeit.length,
                                      messstelleKenngroesse.length,
                                      kenngroesseDetailUw.length,
                                      kenngroesseDetailZeit.length
                                    );
                                  }}
                                  style={{
                                    minWidth: "unset",
                                    color: "rgb(177, 177, 177)",
                                  }}
                                >
                                  <Close />
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        }
                      ></Tab>
                    ))}
                    {messstelleKenngroesse.map((elem) => (
                      <Tab
                        fullWidth={true}
                        style={{
                          minWidth: "max-content",
                          marginRight: "15px",
                          color: elem.isOld ? "red" : "",
                        }}
                        key={elem.uw + elem.kategorie}
                        value={elem.uw + elem.kategorie}
                        label={
                          <Grid container>
                            <Grid container item md={12}>
                              <Grid item style={{ alignSelf: "center" }}>
                                <Typography style={{ fontSize: "14px" }}>
                                  {elem.uw + " (Kenngr.)"}
                                </Typography>
                              </Grid>
                              <Grid item style={{ textAlignLast: "right" }}>
                                <Button
                                  component={"div"}
                                  key={elem.uw + elem.kategorie}
                                  onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    dispatch(
                                      deleteTabForMessstelleKenngroesse(elem.uw)
                                    );
                                    closeTab(
                                      elem.uw + elem.kategorie,
                                      messstelleZeit.length,
                                      messstelleKenngroesse.length,
                                      kenngroesseDetailUw.length,
                                      kenngroesseDetailZeit.length
                                    );
                                  }}
                                  style={{
                                    minWidth: "unset",
                                    color: "rgb(177, 177, 177)",
                                  }}
                                >
                                  <Close />
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        }
                      ></Tab>
                    ))}
                    {kenngroesseDetailUw.map((elem) => (
                      <Tab
                        fullWidth={true}
                        style={{
                          minWidth: "max-content",
                          marginRight: "15px",
                          color: elem.isOld ? "red" : "",
                        }}
                        key={elem.kenngroesse + elem.kategorie}
                        value={elem.kenngroesse + elem.kategorie}
                        label={
                          <Grid container>
                            <Grid container item md={12}>
                              <Grid item style={{ alignSelf: "center" }}>
                                <Typography style={{ fontSize: "14px" }}>
                                  {elem.kenngroesse + " (UW)"}
                                </Typography>
                              </Grid>
                              <Grid item style={{ textAlignLast: "right" }}>
                                <Button
                                  component={"div"}
                                  key={elem.kenngroesse + elem.kategorie}
                                  onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    dispatch(
                                      deleteTabForKenngroesseDetailUw(
                                        elem.kenngroesse
                                      )
                                    );
                                    closeTab(
                                      elem.kenngroesse + elem.kategorie,
                                      messstelleZeit.length,
                                      messstelleKenngroesse.length,
                                      kenngroesseDetailUw.length,
                                      kenngroesseDetailZeit.length
                                    );
                                  }}
                                  style={{
                                    minWidth: "unset",
                                    color: "rgb(177, 177, 177)",
                                  }}
                                >
                                  <Close />
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        }
                      ></Tab>
                    ))}
                    {kenngroesseDetailZeit.map((elem) => (
                      <Tab
                        fullWidth={true}
                        style={{
                          minWidth: "max-content",
                          marginRight: "15px",
                          color: elem.isOld ? "red" : "",
                        }}
                        key={elem.kenngroesse + elem.kategorie}
                        value={elem.kenngroesse + elem.kategorie}
                        label={
                          <Grid container>
                            <Grid container item md={12}>
                              <Grid item style={{ alignSelf: "center" }}>
                                <Typography style={{ fontSize: "14px" }}>
                                  {elem.kenngroesse + " (Zeit)"}
                                </Typography>
                              </Grid>
                              <Grid item style={{ textAlignLast: "right" }}>
                                <Button
                                  component={"div"}
                                  key={elem.kenngroesse + elem.kategorie}
                                  onClick={(e: React.MouseEvent) => {
                                    e.stopPropagation();
                                    dispatch(
                                      deleteTabForKenngroesseDetailZeit(
                                        elem.kenngroesse
                                      )
                                    );
                                    closeTab(
                                      elem.kenngroesse + elem.kategorie,
                                      messstelleZeit.length,
                                      messstelleKenngroesse.length,
                                      kenngroesseDetailUw.length,
                                      kenngroesseDetailZeit.length
                                    );
                                  }}
                                  style={{
                                    minWidth: "unset",
                                    color: "rgb(177, 177, 177)",
                                  }}
                                >
                                  <Close />
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        }
                      ></Tab>
                    ))}
                  </Tabs>
                  {selectedTabForTables == "zeitUmspannwerk" ? (
                    uwZeitLoading ? (
                      <CircularProgress
                        size="30px"
                        style={{ marginTop: "100px", padding: "1px" }}
                      />
                    ) : uwZeit.length > 0 &&
                      (kenngroesseFilter.length > 0 ||
                        messstelleFilter.length > 0) ? (
                      <Grid
                        container
                        item
                        md={12}
                        style={{ paddingTop: "20px" }}
                      >
                        <UmspannwerkZeitGrid />
                      </Grid>
                    ) : (
                      <React.Fragment>
                        <Grid
                          item
                          md={12}
                          style={{
                            textAlign: "left",
                            marginRight: "20px",
                            marginLeft: "50px",
                            paddingTop: "100px",
                          }}
                        >
                          <div style={{ height: "30vh" }}>
                            {firstLoadOfAnwenden ? (
                              <Typography>
                                Bitte Filter definieren, um PQ Index anzuzeigen.
                                Bestätigen Sie den Filter über anwenden.
                              </Typography>
                            ) : (
                              <Typography>Keine Daten vorhanden.</Typography>
                            )}
                          </div>
                        </Grid>
                      </React.Fragment>
                    )
                  ) : (
                    ""
                  )}
                  {selectedTabForTables == "umspannwerkKenngroesse" ? (
                    uwKenngroesseLoading ? (
                      <CircularProgress
                        size="30px"
                        style={{ marginTop: "100px", padding: "1px" }}
                      />
                    ) : uwKenngroesse.length > 0 &&
                      (kenngroesseFilter.length > 0 ||
                        messstelleFilter.length > 0) ? (
                      <Grid
                        container
                        item
                        md={12}
                        style={{ paddingTop: "20px" }}
                      >
                        <UmspannwerkKenngroesseGrid />
                      </Grid>
                    ) : (
                      <React.Fragment>
                        <Grid
                          item
                          md={12}
                          style={{
                            textAlign: "left",
                            marginRight: "20px",
                            marginLeft: "50px",
                            paddingTop: "100px",
                          }}
                        >
                          <div style={{ height: "30vh" }}>
                            {firstLoadOfAnwenden ? (
                              <Typography>
                                Bitte Filter definieren, um PQ Index anzuzeigen.
                                Bestätigen Sie den Filter über anwenden.
                              </Typography>
                            ) : (
                              <Typography>Keine Daten vorhanden.</Typography>
                            )}
                          </div>
                        </Grid>
                      </React.Fragment>
                    )
                  ) : (
                    ""
                  )}
                  {selectedTabForTables == "kenngroesseZeit" ? (
                    kenngroesseZeitLoading ? (
                      <CircularProgress
                        size="30px"
                        style={{ marginTop: "100px", padding: "1px" }}
                      />
                    ) : kenngroesseZeit.length > 0 &&
                      (kenngroesseFilter.length > 0 ||
                        messstelleFilter.length > 0) ? (
                      <Grid
                        container
                        item
                        md={12}
                        style={{ paddingTop: "20px" }}
                      >
                        <KenngroesseZeitGrid />
                      </Grid>
                    ) : (
                      <React.Fragment>
                        <Grid
                          item
                          md={12}
                          style={{
                            textAlign: "left",
                            marginRight: "20px",
                            marginLeft: "50px",
                            paddingTop: "100px",
                          }}
                        >
                          <div style={{ height: "30vh" }}>
                            {firstLoadOfAnwenden ? (
                              <Typography>
                                Bitte Filter definieren, um PQ Index anzuzeigen.
                                Bestätigen Sie den Filter über anwenden.
                              </Typography>
                            ) : (
                              <Typography>Keine Daten vorhanden.</Typography>
                            )}
                          </div>
                        </Grid>
                      </React.Fragment>
                    )
                  ) : (
                    ""
                  )}
                  {messstelleZeitLoading ? (
                    <CircularProgress
                      size="30px"
                      style={{ marginTop: "100px", padding: "1px" }}
                    />
                  ) : (
                    messstelleZeit.map((elem) =>
                      selectedTabForTables == elem.uw + elem.kategorie ? (
                        <Grid
                          container
                          item
                          md={12}
                          style={{ paddingTop: "20px" }}
                        >
                          {messstelleZeit.length == 0 ? (
                            <Typography>Keine Daten vorhanden.</Typography>
                          ) : (
                            <MessstelleZeitGrid
                              uw={elem.uw}
                              kategorie={elem.kategorie}
                              liste_header={elem.liste_header}
                              liste_horizental={elem.liste_horizental}
                              liste_vertikal={elem.liste_vertikal}
                              min_all={elem.min_all}
                              pqIndex={elem.pqIndex}
                            />
                          )}
                        </Grid>
                      ) : (
                        ""
                      )
                    )
                  )}
                  {messstelleKenngroesseLoading ? (
                    <CircularProgress
                      size="30px"
                      style={{ marginTop: "100px", padding: "1px" }}
                    />
                  ) : (
                    messstelleKenngroesse.map((elem) =>
                      selectedTabForTables == elem.uw + elem.kategorie ? (
                        <Grid
                          container
                          item
                          md={12}
                          style={{ paddingTop: "20px" }}
                        >
                          {messstelleKenngroesse.length == 0 ? (
                            <Typography>Keine Daten vorhanden.</Typography>
                          ) : (
                            <MessstelleKenngroesseGrid
                              uw={elem.uw}
                              kategorie={elem.kategorie}
                              liste_header={elem.liste_header}
                              liste_horizental={elem.liste_horizental}
                              liste_vertikal={elem.liste_vertikal}
                              min_all={elem.min_all}
                              pqIndex={elem.pqIndex}
                            />
                          )}
                        </Grid>
                      ) : (
                        ""
                      )
                    )
                  )}
                  {kenngroesseDetailUwLoading ? (
                    <CircularProgress
                      size="30px"
                      style={{ marginTop: "100px", padding: "1px" }}
                    />
                  ) : (
                    kenngroesseDetailUw.map((elem) =>
                      selectedTabForTables ==
                        elem.kenngroesse + elem.kategorie ? (
                        <Grid
                          container
                          item
                          md={12}
                          style={{ paddingTop: "20px" }}
                        >
                          {kenngroesseDetailUw.length == 0 ? (
                            <Typography>Keine Daten vorhanden.</Typography>
                          ) : (
                            <KenngroesseDetailUwGrid
                              kenngroesse={elem.kenngroesse}
                              kategorie={elem.kategorie}
                              liste_header={elem.liste_header}
                              liste_horizental={elem.liste_horizental}
                              liste_vertikal={elem.liste_vertikal}
                              min_all={elem.min_all}
                              pqIndex={elem.pqIndex}
                            />
                          )}
                        </Grid>
                      ) : (
                        ""
                      )
                    )
                  )}
                  {kenngroesseDetailZeitLoading ? (
                    <CircularProgress
                      size="30px"
                      style={{ marginTop: "100px", padding: "1px" }}
                    />
                  ) : (
                    kenngroesseDetailZeit.map((elem) =>
                      selectedTabForTables ==
                        elem.kenngroesse + elem.kategorie ? (
                        <Grid
                          container
                          item
                          md={12}
                          style={{ paddingTop: "20px" }}
                        >
                          {kenngroesseDetailZeit.length == 0 ? (
                            <Typography>Keine Daten vorhanden.</Typography>
                          ) : (
                            <KenngroesseDetailZeitGrid
                              kenngroesse={elem.kenngroesse}
                              kategorie={elem.kategorie}
                              liste_header={elem.liste_header}
                              liste_horizental={elem.liste_horizental}
                              liste_vertikal={elem.liste_vertikal}
                              min_all={elem.min_all}
                              pqIndex={elem.pqIndex}
                            />
                          )}
                        </Grid>
                      ) : (
                        ""
                      )
                    )
                  )}
                </Grid>
                {filter ? (
                  <React.Fragment>
                    <Grid item md={5} style={{ paddingLeft: "16px" }}>
                      <Grid
                        container
                        md={12}
                        style={{
                          paddingTop: "5px",
                          paddingBottom: "24px",
                          paddingRight: "24px",
                          justifyContent: "end",
                        }}
                      >
                        <Grid
                          container
                          md={1}
                          style={{
                            margin: "0px",
                            width: "10px",
                            maxWidth: "20px",
                            padding: "0px",
                          }}
                        >
                          <Divider orientation="vertical" flexItem />
                        </Grid>
                        <Grid item container md={11}>
                          <Grid item md={12}>
                            <Tabs
                              value={selectedTab}
                              onChange={(event, value) => setSelectedTab(value)}
                              indicatorColor="secondary"
                              textColor="secondary"
                              TabIndicatorProps={{
                                style: {
                                  height: "5px",
                                },
                              }}
                            >
                              <Tab label="Zeit" value="zeit" />
                              <Tab label={"Messstelle (" + messstelleFilterWert.length + ")"} value="messstelle" />
                              <Tab label={"Kenngröße (" + kenngroesseFilterWert.length + ")"} value="kenngroesse" />
                              <Tab label="Grenzwertsatz" value="grenzwerte" />
                            </Tabs>
                            {selectedTab == "zeit" ? <ZeitFilter /> : ""}
                            {selectedTab == "messstelle" ? (
                              <MessstellenFilter name={"pqIndex"} />
                            ) : (
                              ""
                            )}
                            {selectedTab == "kenngroesse" ? (
                              <KenngroesseFilter name={"pqIndex"} />
                            ) : (
                              ""
                            )}
                            {selectedTab == "grenzwerte" ? (
                              <GrenzwertFilter />
                            ) : (
                              ""
                            )}
                            <Grid
                              container
                              md={12}
                              style={{ marginTop: "30px" }}
                            >
                              <Grid item container md={6} />
                              <Grid
                                item
                                container
                                md={6}
                                style={{ justifyContent: "end" }}
                              >
                                <Button
                                  style={{ width: "45%" }}
                                  variant="contained"
                                  onClick={() => {
                                    dispatch(resetKenngroesseWert());
                                    dispatch(resetMessstelleWert());
                                    dispatch(resetAktuellerGrenzwertsatz());
                                    dispatch(resetEndeCounter());
                                    dispatch(resetStartCounter());
                                    dispatch(resetEndeZeitraum());
                                    dispatch(resetStartZeitraum());
                                    dispatch(resetStartDatum());
                                    dispatch(resetSlider());
                                    dispatch(resetEndeDatum());
                                    dispatch(setIsChangedGrenzwert(false));
                                    dispatch(setIsChangedMessstelle(false));
                                    dispatch(setIsChangedKenngroesse(false));
                                    dispatch(setIsChangedZeit(false));
                                    dispatch(setOldTabMessstelle());
                                    dispatch(setOldTabKenngroesse());
                                  }}
                                  color="default"
                                  className={classes.showDuoButton}
                                  disabled={
                                    !isChangedZeit &&
                                    !isChangedKenngroesse &&
                                    !isChangedMessstelle &&
                                    !isChangedGrenzwert
                                  }
                                >
                                  Rückgängig
                                </Button>
                                <Button
                                  style={{ width: "45%" }}
                                  variant="contained"
                                  onClick={() => {
                                    dispatch(setKenngroesseWert());
                                    dispatch(setMessstelleWert());
                                    dispatch(setAktuellerGrenzwertsatz());
                                    dispatch(setEndeZeitraum());
                                    dispatch(setEndeCounter());
                                    dispatch(setStartZeitraum());
                                    dispatch(setStartCounter());
                                    dispatch(setStartDatum());
                                    dispatch(setEndeDatum());
                                    dispatch(setSlider());
                                    dispatch(setIsChangedGrenzwert(false));
                                    dispatch(setIsChangedMessstelle(false));
                                    dispatch(setIsChangedKenngroesse(false));
                                    dispatch(setIsChangedZeit(false));
                                    dispatch(
                                      getUwZeit(
                                        messstelleFilterWert,
                                        kenngroesseFilterWert,
                                        startDatum,
                                        endeDatum,
                                        pqIndexSlider[0],
                                        pqIndexSlider[1],
                                        grenzwertsatz,
                                        true
                                      )
                                    );
                                    dispatch(
                                      getUwKenngroesse(
                                        messstelleFilterWert,
                                        kenngroesseFilterWert,
                                        startDatum,
                                        endeDatum,
                                        pqIndexSlider[0],
                                        pqIndexSlider[1],
                                        grenzwertsatz,
                                        true,
                                        true
                                      )
                                    );
                                    dispatch(
                                      getKenngroesseZeit(
                                        messstelleFilterWert,
                                        kenngroesseFilterWert,
                                        startDatum,
                                        endeDatum,
                                        pqIndexSlider[0],
                                        pqIndexSlider[1],
                                        grenzwertsatz,
                                        true,
                                        true
                                      )
                                    );
                                    dispatch(setOldTabMessstelle());
                                    dispatch(setOldTabKenngroesse());
                                    dispatch(setFirstLoadOfAnwenden(false));
                                  }}
                                  color="secondary"
                                  className={classes.showDuoButton}
                                  disabled={
                                    // (!isChangedZeit && 
                                    // !isChangedKenngroesse && 
                                    // !isChangedMessstelle ) 
                                    // || 
                                    (messstelleFilterWert.length == 0 ||
                                      kenngroesseFilterWert.length == 0) ||
                                    (startDatum === endeDatum) ||
                                    endDate == 0} >

                                  Anwenden
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </React.Fragment>
                ) : ""}
              </Grid>
            </Grid>
          </div>
        </form>
      </Paper>
    </div>
  );
}
